exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3XItbwKjX2coP_-V9Gc_Fr{padding:1.42857rem}@media only screen and (min-width:640px){._3XItbwKjX2coP_-V9Gc_Fr{padding:2.14286rem}}._29lZvuDCcyknNi7p2i3bny{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"GrammarPro_wrapper": "_3XItbwKjX2coP_-V9Gc_Fr",
	"GrammarPro_report": "_29lZvuDCcyknNi7p2i3bny"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/GrammaPro/style.postcss
// module id = 1902
// module chunks = 0